import api from './api';
export interface FinanceResultSourceReport {
  tenantId: string; storeId: string; orderId: string; currency: string; knowledgeAsOf: string;
  settlement?: { quality: 'SOURCE_REPORTED_SNAPSHOT'; currentOrderGross: string | null;
    sourceReportedNetPayment: string | null; sourceReportedDeliveredRevenueGross: string | null;
    sourceReportedDeliveredRevenueNet: string | null;
    deliveredUnits: Array<{ lineRef: string; ordered: number; reportedDelivered: number }>;
    contributions: Array<{ basis: 'NET' | 'GROSS'; knownDocumentCosts: string; afterKnownDocumentCosts: string | null; complete: false }>;
    reasonCodes: string[]; sourceHash: string };
  sourceHash: string; confirmedResult: null; estimatedResult: null; reasonCodes: string[];
  observation: null | { revisionId: string; contentIntegrity: 'VERIFIED' | 'LEGACY_UNVERIFIABLE';
    observedAt: string; reconciliation: { reportedOrderAmount: string | null; reportedPaidAmount: string | null;
      reportedCompletedRefundAmount: string | null; observedNetPayment: string | null };
    basis: null | { productLineCount: number; total: string; tax: string } };
  journal: { status: string; receipt: null | { id: string; throughSequence: number; orderRevisionCount: number;
    captureGap: boolean; acquiredAt: string; receiptIntegrity: 'VERIFIED' } };
  parcels: null | { id: string; parcelCount: number; quantities: Array<{
    lineRef: string; ordered: number; declaredOriginal: number; unassigned: number }> };
  costs: { revisionCount: number; currentDocumentCount: number; status: 'READ' | 'UNAVAILABLE';
    buckets: Array<{ currency: string; basis: 'NET' | 'GROSS'; knownDocumentNet: string | null }> };
  costCoverage: { orderDocuments: { status: 'COVERED' | 'NONE'; documentCount: number } };
}
export const readFinanceResultSources = (storeId: string, orderId: string, knowledgeAsOf?: string) =>
  api.get<FinanceResultSourceReport>(`/finance/orders/${encodeURIComponent(orderId)}/result-sources`,
    { params: { storeId, knowledgeAsOf } });

export const readMarketingResultSources = (brandId: string, factId: string, knowledgeAsOf?: string) =>
  api.get<FinanceResultSourceReport>(`/marketing/brands/${encodeURIComponent(brandId)}/contribution/orders/${encodeURIComponent(factId)}/result-sources`,
    { params: { knowledgeAsOf } });
